'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$Switcher$1(name, button) {
  this.t7 = null;
  this.t6 = null;
  this.t7 = name;
  this.t6 = button;
}
export { $c_Lsamples_Sealed$package$Switcher$1 as $c_Lsamples_Sealed$package$Switcher$1 };
$p = $c_Lsamples_Sealed$package$Switcher$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$Switcher$1;
/** @constructor */
function $h_Lsamples_Sealed$package$Switcher$1() {
}
export { $h_Lsamples_Sealed$package$Switcher$1 as $h_Lsamples_Sealed$package$Switcher$1 };
$h_Lsamples_Sealed$package$Switcher$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-693014300), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Sealed$package$Switcher$1)) {
    if ((this.t7 === x$0.t7)) {
      var x = this.t6;
      var x$2 = x$0.t6;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "Switcher";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.t7;
  }
  if ((n === 1)) {
    return this.t6;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lsamples_Sealed$package$Switcher$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.es)));
}
export { $isArrayOf_Lsamples_Sealed$package$Switcher$1 as $isArrayOf_Lsamples_Sealed$package$Switcher$1 };
var $d_Lsamples_Sealed$package$Switcher$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$Switcher$1, "samples.Sealed$package$Switcher$1", ({
  es: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Sealed$package$Switcher$1 as $d_Lsamples_Sealed$package$Switcher$1 };
